import React from 'react';

export default function ButtonAppBar() {
    return (
        <footer>
            Copyright © 2020 Quicker All Rights Reserved.
        </footer>
    );
}
